export default "__VITE_ASSET__Dv31fNqz__"